import { AccessRight } from 'interfaces/Clients/clinician';
import { CustomFeature } from 'utils/UserContextProvider';

import { PractitionersDetailsInterface } from '../Practitioners/practitionersListing';

export enum ClinicianMedicareRole {
  ClinicalPsychologists = 'clinicalPsychologists',
  RegisteredPsychologists = 'registeredPsychologists',
  OccupationalTherapists = 'occupationalTherapists',
  SocialWorkers = 'socialWorkers'
}

export enum TacklitResource {
  Invoice = 'invoice',
  AppointmentRate = 'appointmentRate'
}

interface AnalyticContent {
  title: string;
  embedLink: string;
}

export interface ProfileInterface {
  _id: string;
  specialisations: string[];
  consultantLocations: string[];
  title: string;
  titleValue: string;
  name: string;
  practice?: PracticeInterface;
  practices: {
    locations: string[];
    logo: string;
    name: string;
    mobileNumber: string;
  }[];
  accessRight: AccessRight;
  avatar?: string;
  bio?: string;
  partOfPractice?: boolean;
  email: string;
  mobileNumber: string;
  caseLoad: PractitionersDetailsInterface['caseLoad'];
  workingSchedule: PractitionersDetailsInterface['workingSchedule'];
  workingScheduleNew: PractitionersDetailsInterface['workingSchedule'];
  customFeatures?: CustomFeature[];
  accountSettings?: {
    absenceReasons?: string[];
    bazaarUrl?: string;
    bazaarChapterTagIds?: string[];
    customLabels?: Record<string, string>;
    timezone?: string;
    permissions?: {
      [key in AccessRight]?: {
        readDenied?: TacklitResource[];
        writeDenied?: TacklitResource[];
      };
    };
  };
  profileSettings?: {
    analyticContent?: AnalyticContent[];
  };
  medicare?: {
    role: ClinicianMedicareRole;
  };
  helmControl?: HelmControlInterface;
  isProfileListed?: boolean;
  account: {
    misSchool?: {
      status: string;
    };
  };
}

export interface HelmControlInterface {
  headerPhoto?: string;
  additionalPhotos?: string[];
  appointmentPhoto?: string;
  video?: string;
  videoPoster?: string;
  bioPhoto?: string;
  bio?: string;
  bonaFides?: {
    qualifications: {
      active?: boolean;
      value?: string[];
    };
    languages: {
      active?: boolean;
      value?: string[];
    };
    style: {
      active?: boolean;
      value?: string;
    };
    yearsOfExperience: {
      active?: boolean;
      value?: number;
    };
    medicare?: {
      active?: boolean;
      value?: string;
    };
  };
  quote?: string;
  shortDescription?: string;
  welcomeNote?: string;
  isProfileListed?: boolean;
}

export interface PracticeInterface {
  locations: string[];
  logo: string;
  mobileNumber: string;
  name: string;
  slugUrl: string;
}

export interface PracticeInfoInterface {
  practice: Partial<PracticeInterface>;
}
